export const pl = {
  'Homepage': 'Strona Główna',
  'Main Dashboard': 'Panel Główny',
  'Inventory Dashboard': 'Panel Zapasów',
  'Chat': 'Czat',
  'Shelf Planner': 'Planer Półek',
  'Reports': 'Raporty',
  'Catalog': 'Katalog',
  'Stored Items': 'Przechowywane Przedmioty',
  'Replenishments': 'Uzupełnienia',
  'Expired': 'Przeterminowane',
  'Transfers': 'Transfery',
  'In Progress': 'W trakcie',
  'Cancelled': 'Anulowane',
  'Suspended': 'Zawieszone',
  'Customers': 'Klienci',
  'Goods In': 'Przyjęcie Towaru',
  'All': 'Wszystkie',
  'PTL Rack': 'Regał PTL',
  'Cross-Docking': 'Cross-Docking',
  'Resources': 'Zasoby',
  'Shelf Maps': 'Mapy Półek',
  'Warehouses & Zones': 'Magazyny i Strefy',
  'Import Data': 'Import Danych',
  'Units of Measure': 'Jednostki Miary',
  'Smart Tags': 'Inteligentne Etykiety',

  'Login': 'Logowanie do WMS/360',
  'Please enter your credentials to sign in!': 'Proszę wprowadź swoje dane, aby się zalogować!',
  'Email': 'E-mail',
  'Password': 'Hasło',
  'Remember Me': 'Zapamiętaj Mnie',
  'Forgot Password?': 'Zapomniałeś Hasła?',
  'Signing in...': 'Logowanie...',
  'Sign In': 'Zaloguj się',
  'Incorrect email or password': 'Nieprawidłowy email lub hasło',

  'Forgot Password': 'Zapomniałeś hasła',
  'Check your email': 'Sprawdź swoją pocztę e-mail',
  'We have sent a password recovery instruction to your email': 'Wysłaliśmy instrukcję odzyskiwania hasła na Twój adres e-mail',
  'Please enter your email address to receive a verification code': 'Proszę podać swój adres e-mail, aby otrzymać kod weryfikacyjny',
  'Resend Email': 'Wyślij email ponownie',
  'Send Email': 'Wyślij email',
  'Back to': 'Powrót do',
  'Sign in': 'Zaloguj się',
  'Reset done': 'Resetowanie zakończone',
  'Your password has been successfully reset': 'Twoje hasło zostało pomyślnie zresetowane',
  'Set new password': 'Ustaw nowe hasło',
  'Your new password must different to previous password': 'Twoje nowe hasło musi różnić się od poprzedniego',
  'Confirm Password': 'Potwierdź hasło',
  'Company Name': 'Nazwa firmy',
  'Sign Up': 'Zarejestruj się',
  'Creating Account...': 'Tworzenie konta...',
  'Already have an account?': 'Masz już konto?',
  "Don't have an account?": 'Nie masz konta?',
  'Please enter your email': 'Proszę wprowadzić adres e-mail',
  'Please enter your password': 'Proszę wprowadzić hasło',
  'Please confirm your password': 'Proszę potwierdzić hasło',
  'Please enter your company name': 'Proszę wprowadzić nazwę firmy',
  'Your passwords do not match': 'Hasła nie są zgodne',

  'Submitting ...': 'Przesyłanie...',
  'Submit': 'Prześlij',
  'Continue': 'Kontynuuj',

  'Inventory': 'Zapasy',
  'Dashboard': 'Panel',
  'Filter': 'Filtr',
  'Print Label': 'Drukuj etykietę',
  'Printing label for {{article}}': 'Drukowanie etykiety dla {{article}}',
  'Today': 'Dzisiaj',
  'Yesterday': 'Wczoraj',
  'This Week': 'Ten tydzień',
  'Last 7 Days': 'Ostatnie 7 dni',
  'Last 30 Days': 'Ostatnie 30 dni',
  'This Month': 'Ten miesiąc',
  'Pick Confirmed': 'Pobrania Potwierdzone',
  'Sold': 'Sprzedane',
  'Short Items': 'Brakujące Przedmioty',
  'Fix': 'Naprawić',
  'Status': 'Status',
  'Paid': 'Zapłacone',
  'Pending': 'Oczekujące',
  'Failed': 'Nieudane',
  'Date': 'Data',
  'Amount': 'Ilość',
  'Snapshot Variance Reports': 'Raporty różnic wynikających ze zdjęć',
  'Unique Items': 'Unikalne przedmioty',
  'Total Item Count': 'Całkowita liczba przedmiotów',
  'Stock Count': 'Inwentaryzacja',
  'Inbound Items': 'Przedmioty przychodzące',

  'Available': 'Dostępne',
  'Low Stock': 'Niski stan',
  'Out of Stock': 'Brak na stanie',
  'Total Stock': 'Całkowity stan magazynowy',

  'Value Distribution': 'Rozkład Wartości',
  'Vertical': 'Windy',
  'Racking': 'Regały',
  'Quarantine': 'Kwarantanna',
  'Inspection': 'Inspekcja',

  'Variance Value': 'Wartość Wariancji',
  'Warehouse Capacity': 'Pojemność Magazynu',

  'Activities': 'Działania',
  'View All': 'Pokaż Wszystkie',
  'No Activities': 'Brak Działań',

  'Batch Cycles': 'Cykle Partii',
  'Batch Runs': 'Uruchomienia partii',
  'Performance': 'Wydajność',
  'Staff': 'Personel',

  'Pending Jobs': 'Oczekujące Zadania',
  'Completed Jobs': 'Zakończone Zadania',
  'Put away': 'Zatowarowanie',
  'Picks Completed': 'Pobrania Zrealizowane',
  'Active Staff': 'Aktywny Personel',
  'Work Load': 'Obciążenie Pracą',

  'Fulfilment Time (avg)': 'Średni czas realizacji',
  'Order': 'Zamówienie',
  'Total': 'Suma',
  'Latest Orders': 'Najnowsze Zamówienia',
  'View Orders': 'Zobacz Zamówienia',

  'Categories': 'Kategorie',

  'Orders Dashboard': 'Panel zamówień',
  'View your current sales & summary': 'Zobacz aktualną sprzedaż i podsumowanie',
  'Sales Report': 'Raport sprzedaży',
  'Export Report': 'Eksportuj raport',

  'Revenue': 'Przychody',
  'Orders': 'Zamówienia',
  'Purchases': 'Zakupy',

  'Processing': 'Przetwarzanie',
  'Return': 'Zwrot',
  'Units': 'Jednostki',
  'Scan Confirmed': 'Skan Potwierdzony',

  'Top Selling': 'Najlepiej sprzedające się',
  'View Products': 'Zobacz Produkty',
  'Article': 'Artykuł',
  'Title': 'Tytuł',
  'Quantity': 'Ilość',
  'Expired Date': 'Data Ważności',

  'Product': 'Produkt',
  'Products': 'Produkty',
  'Warehouse': 'Magazyn',
  'Zone': 'Strefa',
  'Lift': 'Winda',
  'Lifts': 'Windy',
  'Lift Type': 'Typ Windy',
  'Lift Types': 'Typy Wind',
  'Lift Number': 'Numer Windy',
  'Lift Name': 'Nazwa Windy',
  'Shelf': 'Półka',
  'Shelves': 'Półki',
  'User': 'Użytkownik',
  'Users': 'Użytkownicy',
  'User name': 'Nazwa użytkownika',
  'Username': 'Nazwa użytkownika',
  'Access point': 'Punkt dostępu',
  'Barcode': 'Kod kreskowy',
  'Width': 'Szerokość',
  'Height': 'Wysokość',
  'Depth': 'Głębokość',
  'Depths': 'Głębokości',
  'Compartment': 'Przegroda',
  'Compartments': 'Przegrody',
  'Type': 'Typ',
  'S/C/D': 'S/C/D',
  'Created': 'Utworzono',
  'Color': 'Kolor',
  'Count': 'Liczba',
  'Counts': 'Liczenia',
  'Max': 'Maks',
  'Put': 'Zatowarowanie',
  'Pick': 'Pobranie',
  'Location': 'Lokalizacja',
  'Locations': 'Lokalizacje',
  'Description': 'Opis',
  'Pick Sheet': 'Lista pobrań',
  'Movements': 'Zdarzenia',
  'Movement': 'Zdarzenie',
  'Job Name': 'Nazwa Zadania',
  'Required Quantity': 'Wymagana Ilość',
  'Actual Quantity': 'Rzeczywista Ilość',
  'Other': 'Inne',
  'Bin': 'Pojemnik',
  'Bins': 'Pojemniki',
  'Setting': 'Ustawienie',
  'Settings': 'Ustawienia',
  'Max Qty.': 'Maks. Ilość',

  'Filter by dates range': 'Filtruj wg zakresu dat',
  'Min Qty.': 'Min. Ilość',
  'Current Stock': 'Aktualny Zapas',
  'Transfer': 'Transfer',
  'Add Product': 'Dodaj Produkt',

  'No product found!': 'Nie znaleziono produktu!',
  'Add': 'Dodaj',
  'Cancel': 'Anuluj',
  'Save': 'Zapisz',
  'Edit': 'Edytuj',
  'Delete': 'Usuń',
  'Discard': 'Odrzuć',

  'Track #': 'Numer przesyłki',
  'Order Date': 'Data Zamówienia',
  'Shipping Method': 'Metoda Wysyłki',
  'Supplier': 'Dostawca',

  'Related Products': 'Powiązane Produkty',
  'Consignment': 'Przesyłka',
  'Consigned': 'Wysłany',
  'Owner': 'Właściciel',
  'Search Owner': 'Szukaj Właściciela',

  'Scan to pick': 'Pobieraj skanując',
  'Active': 'Aktywny',
  'Block': 'Blokuj',
  'Pick Method': 'Metoda Pobierania',
  'FIFO': 'FIFO',
  'Optimised': 'Zoptymalizowany',
  'Security': 'Bezpieczeństwo',
  'Stock Take': 'Inwentaryzacja',
  'Stock Valuation': 'Wycena zapasów',

  'Unit Of Measure': 'Jednostka Miary',
  'Print Label on Pick': 'Drukuj Etykietę przy Pobieraniu',
  'Is Serialised': 'Serializacja',

  'Receiving': 'Odbiór',

  'This field is required': 'To pole jest wymagane',
  'Enter correct url!': 'Wprowadź poprawny URL!',
  'Something wrong! Can not upload file': 'Coś poszło nie tak! Nie można przesłać pliku',
  'Max quantity of the bins are required': 'Wymagana maksymalna ilość w pojemnikach',
  'Product successfully added': 'Produkt dodany pomyślnie',
  'article is existed.': 'Artykuł już istnieje.',
  'Error !!!': 'Błąd !!!',
  'Min Quantity': 'Min. Ilość',
  'UOM': 'JM',
  'Fifo': 'FiFo',
  'Pick multiplier': 'Mnożnik pobierania',
  'Put away multiplier': 'Mnożnik odkładania',
  'Buy Price': 'Cena Zakupu',
  'Sell Price': 'Cena Sprzedaży',
  'ERP Code': 'Kod ERP',
  'Manufacturer': 'Producent',
  'Model': 'Model',
  'Make': 'Marka',
  'Is serial numbered': 'Posiada numer seryjny',
  'H1': 'H1',
  'H2': 'H2',
  'H3': 'H3',
  'H4': 'H4',
  'H5': 'H5',
  'H6': 'H6',
  'Auto print label': 'Automatyczne drukowanie etykiet',
  'Scan pick': 'Skanowanie pobrania',
  'Product Image': 'Obraz Produktu',
  'Please upload a image file!': 'Proszę przesłać plik obrazu!',
  'Upload image cannot more then {{size}}kb !': 'Przesyłany obraz nie może być większy niż {{size}}kb!',
  'Add or change image for the product': 'Dodaj lub zmień obraz produktu',
  'Drop your image here, or': 'Upuść obraz tutaj lub',
  'browse': 'przeglądaj',
  'Support: image files': 'Obsługa: pliki obrazów',
  'Use Webcam': 'Użyj kamery internetowej',
  'Capture photo': 'Zrób zdjęcie',
  'Are you sure you want to delete this product? All record related to this product will be deleted as well. This action cannot be undone.': 'Czy na pewno chcesz usunąć ten produkt? Wszystkie powiązane z nim dane zostaną również usunięte. Tej akcji nie można cofnąć.',
  'Delete product': 'Usuń produkt',

  'Counted': 'Policzone',
  'Completed': 'Zakończone',

  'Category': 'Kategoria',
  'Created At': 'Utworzono',
  'Started At': 'Rozpoczęto',
  'Completed At': 'Zakończono',
  'Item count': 'Liczba przedmiotów',
  'Value': 'Wartość',
  'Recounted': 'Przeliczono',
  'Variance': 'Różnica',
  'Approved': 'Zatwierdzono',

  'Checked': 'Sprawdzone',
  'Checked By': 'Sprawdził',
  'Checked Date': 'Data Sprawdzenia',
  'Comment': 'Komentarz',
  'Sending ...': 'Wysyłanie...',
  'Send': 'Wyślij',
  'Recount All': 'Przelicz Wszystko',
  'Approval All': 'Zatwierdź Wszystko',
  'Matching': 'Dopasowanie',
  'Recount': 'Przeliczenie',

  'Count Name': 'Nazwa Liczenia',
  'Cycle Count': 'Liczenie cykliczne',
  'Select the stock take group to count.': 'Wybierz grupę zapasów do policzenia.',
  'In which warehouse': 'W którym magazynie',
  'Should the articles being counted now be made inactive so they can not be picked or put until after they have been counted ?': 'Czy artykuły, które są teraz liczone, powinny zostać dezaktywowane, aby nie można było ich pobierać ani odkładać do czasu zakończenia liczenia?',
  'Cycle A': 'Cykl A',
  'Cycle B': 'Cykl B',
  'Cycle C': 'Cykl C',
  'No Count': 'Brak liczenia',

  'All Locations': 'Wszystkie lokalizacje',
  'Shelf Size': 'Rozmiar Półki',
  'Lift/Rack Name': 'Nazwa Windy/Regału',

  'Bulk': 'Hurtowo',
  'Cross Docking': 'Cross-Docking',
  'Inspections': 'Inspekcje',
  'Locker': 'Szafka',
  'Lockers': 'Szafki',
  'Open Door': 'Otwórz drzwi',
  'Set Size Info': 'Ustaw informacje o rozmiarze',
  'Size': 'Rozmiar',
  'Put Date': 'Data złożenia',
  'Contact': 'Kontakt',
  'Are you sure you want to delete this lift? All record related to this lift will be deleted as well. This action cannot be undone.': 'Czy na pewno chcesz usunąć tę windę? Wszystkie dane związane z tą windą zostaną również usunięte. Tej czynności nie można cofnąć.',
  'Delete lift': 'Usuń Windę',
  'Add Location': 'Dodaj Lokalizację',
  'Location successfully added': 'Lokalizacja dodana pomyślnie',
  'The location is existed': 'Lokalizacja już istnieje',
  'Rack Number': 'Numer Regału',
  'Start Rack': 'Regał początkowy',
  'End Rack': 'Regał końcowy',
  'Creating racks': 'Tworzenie regałów',
  'Rack': 'Regał',
  'Rack Name': 'Nazwa Regału',
  'Rack Description': 'Opis Regału',
  'Shelves (S)': 'Półki (S)',
  'Compartments (C)': 'Przegrody (C)',
  'Depths (D)': 'Głębokości (D)',
  'Box Positions (D)': 'Pozycje pudeł (D)',
  'Shelf Width (mm)': 'Szerokość Półki (mm)',
  'Shelf Depth (mm)': 'Głębokość Półki (mm)',
  'No lift found!': 'Nie znaleziono windy!',
  'No locker found!': 'Nie znaleziono szafki',
  'Required': 'Wymagane',

  'Speed': 'Prędkość',
  'Security Groups': 'Grupy Bezpieczeństwa',
  'Notes': 'Notatki',

  'Assign a Shelf map': 'Przypisz mapę półek',
  'I understand': 'Rozumiem',
  'Select the shelf map to assign.': 'Wybierz mapę półek do przypisania.',
  'Actions': 'Akcje',
  'Shelf Map': 'Mapa Półek',

  'Add Vertical': 'Dodaj Windę',
  'Edit Vertical': 'Edytuj Windę',
  'Please Select': 'Proszę Wybrać',
  'Lift Group': 'Grupa Wind',
  'Lock Timer (seconds)': 'Czas Blokady (sekundy)',
  'Number Of Shelves': 'Liczba Półek',
  'Shelf Width': 'Szerokość Półki',
  'Shelf Depth': 'Głębokość Półki',
  'Serial Number': 'Numer Seryjny',
  'License Key': 'Klucz Licencyjny',
  'Login Required': 'Wymagane Logowanie',
  'Manage Articles': 'Zarządzaj Artykułami',
  'Auto Generated Article Codes': 'Automatycznie Generowane Kody Artykułów',
  'Use Security': 'Użyj Zabezpieczeń',
  'Vertical successfully added. Restart the mpx VLM Services to activate the new lift': 'Winda dodana pomyślnie. Uruchom ponownie usługi MPX VLM, aby aktywować nową windę',
  'Generic Error': 'Błąd Ogólny',
  'Access Point': 'Punkt Dostępu',
  'Language': 'Język',
  'Controller PC IP address': 'Adres IP kontrolera PC',
  'Label Printer': 'Drukarka Etykiet',
  'Printer': 'Drukarka',
  'Article Label Format': 'Format Etykiety Artykułu',
  'Question 1': 'Pytanie 1',
  'Question 2': 'Pytanie 2',
  'Allow Picking': 'Zezwól na Pobieranie',
  'Allow Putting': 'Zezwól na Zatowarowanie',
  'Allow Searching': 'Zezwól na Wyszukiwanie',
  'Allow Get Shelf': 'Zezwól na Pobieranie Półki',
  'Reverse Shelf Map': 'Odwróć Mapa Półek',
  'Store After Pick': 'Zapisz po Pobraniu',
  'Store After Job': 'Zapisz po Zadaniu',
  'Manage Lift': 'Zarządzaj Windą',
  'Manage Racking': 'Zarządzaj Regałami',
  'Manage Lockers': 'Zarządzaj Rzafkami',
  'Enable Camera': 'Włącz Kamerę',
  'Left Camera': 'Lewa Kamera',
  'Right Camera': 'Prawa Kamera',
  'Images storage': 'Przechowywanie obrazów',
  'Select images storage': 'Wybierz miejsce przechowywania obrazów',
  'Local Storage': 'Przechowywanie Lokalne',
  'AWS S3': 'AWS S3',
  'Local Path': 'Ścieżka lokalna',
  'AWS Bucket Name': 'Nazwa kosza AWS',
  'AWS Dir Name': 'Nazwa katalogu AWS',
  'AWS Region': 'Region AWS',
  'AWS Access Key Id': 'Identyfikator klucza dostępu AWS',
  'AWS Secret Access Key': 'Sekretny klucz dostępu AWS',
  // TODO : orders, pages, resources, shared, components (table, pagination, ...)

  'Put Away': 'Zatowarowanie',
  'Put Away Value': 'Wartość zatowarowania',
  'Returns': 'Zwroty',
  'units': 'jednostki',
  'days': 'dni',
  'Oldest Pending Job': 'Najstarsze Oczekujące Zadanie',
  'Average Orders Per Months': 'Średnia Liczba Zamówień na Miesiąc',
  'Average Pending Time': 'Średni Czas Oczekiwania',
  'Picks': 'Pobrania',
  'Latest Order': 'Najnowsze Zamówienie',
  'Oldest Pending': 'Najstarsze Oczekujące',
  'Created Date': 'Data Utworzenia',
  'Customer': 'Klient',

  'Any question?': 'Jakieś pytania?',
  'Message ...': 'Wiadomość...',
  'Sorry I don\'t understand your question': 'Przepraszam, nie rozumiem twojego pytania',
  'Order History': 'Historia Zamówień',
  'Download Template': 'Pobierz Szablon',
  'Article Information': 'Informacje o Artykule',
  'Drop your file here, or': 'Upuść tutaj swój plik lub',
  'Support': 'Wsparcie',
  'Refresh': 'Odśwież',
  'Export': 'Eksport',
  'Search': 'Szukaj',
  'Total {{number}} Items': 'Łącznie {{number}} przedmiotów',
  'page': 'strona',

  'Copyright': 'Prawa autorskie',
  'Term & Conditions': 'Warunki Użytkowania',
  'Privacy & Policy': 'Prywatność i Polityka',
  'Profile': 'Profil',
  'Sign Out': 'Wyloguj się',

// update 1/3/2025
  'Priority': 'Priorytet',
  'Completed Orders': 'Zakończone Zamówienia',
  'Jobs': 'Zadania',
  'Items': 'Przedmioty',

  'Name': 'Nazwa',
  'Birthday': 'Urodziny',
  'orders': 'zamówienia',
  '(mins)': '(minuty)',
  'per session': 'na sesję',
  'Last Order': 'Ostatnie Zamówienie',
  'Total Customers': 'Łączna Liczba Klientów',
  'Active Customers': 'Aktywni Klienci',
  'New Customers': 'Nowi Klienci',

  'Batch Code': 'Kod Partii',
  'Purchase Order': 'Zamówienie Zakupu',
  'Supplier Name': 'Nazwa Dostawcy',
  'Receipted': 'Odebrane',
  'Progress': 'Postęp',
  'Bay': 'Zatoka',
  'Next Batch': 'Następna Partia',
  'Pending Orders': 'Oczekujące Zamówienia',
  'No data': 'Brak danych',
  'Delivery Address': 'Adres Dostawy',
  'Date Created': 'Data Utworzenia',
  'Date Required': 'Data Wymagana',
  'Date Started': 'Data Rozpoczęcia',
  'Date Processed/Completed': 'Data Przetworzenia/Zakończenia',
  'Processing Time': 'Czas Przetwarzania',
  'Picked': 'Pobrane',
  'Picker': 'Osoba kompletująca',
  'Qty': 'Ilość',
  'View Carrier Details': 'Pokaż Szczegóły Przewoźnika',
  'No order found!': 'Nie znaleziono zamówienia!',
  'Rack Picks': 'Pobrania z Regału',
  'Delete order': 'Usuń zamówienie',
  'Are you sure you want to delete this order? All record related to this order will be deleted as well. This action cannot be undone.': 'Czy na pewno chcesz usunąć to zamówienie? Wszystkie powiązane z nim dane zostaną również usunięte. Tej czynności nie można cofnąć.',
  'Access Denied!': 'Dostęp Zabroniony!',
  'You have no permission to visit this page': 'Nie masz uprawnień do odwiedzenia tej strony',

  'Red': 'Czerwony',
  'Green': 'Zielony',
  'Blue': 'Niebieski',
  'Yellow': 'Żółty',
  'Width (mm)': 'Szerokość (mm)',
  'Depth (mm)': 'Głębokość (mm)',
  'Height (mm)': 'Wysokość (mm)',
  'Weight (kg)': 'Waga (kg)',
  'Volume (m3)': 'Objętość (m3)',
  'Material': 'Materiał',
  'Single Checkbox': 'Pojedynczy checkbox',
  'I agree to the terms and conditions': 'Zgadzam się z warunkami',
  'Clone as rotated bin': 'Klonuj jako pojemnik odwrócony',
  'Bin successfully added': 'Pojemnik dodany pomyślnie',
  'Edit Bin': 'Edytuj Pojemnik',
  'Create New Bin': 'Utwórz Nowy Pojemnik',
  'Delete bin': 'Usuń pojemnik',
  'Are you sure you want to delete this bin? All record related to this bin will be deleted as well. This action cannot be undone.': 'Czy na pewno chcesz usunąć ten pojemnik? Wszystkie dane z nim związane również zostaną usunięte. Tej czynności nie można cofnąć.',
  'Devices': 'Urządzenia',
  'Options': 'Opcje',
  'Download': 'Pobierz',
  'Upload': 'Prześlij',
  'Description of': 'Opis',
  'List of files': 'Lista plików',
  'Stock On Hand': 'Dostępny zapas',
  'Upload file cannot more then {{size}} kb!': 'Przesłany plik nie może być większy niż {{size}} kb!',
  'Upload successful': 'Przesyłanie zakończone sukcesem',
  'Articles': 'Artykuły',
  'Images': 'Obrazy',
  'Upload a png or jpg file with the file name the same as the article id.': 'Prześlij plik png lub jpg, którego nazwa pliku jest taka sama jak identyfikator artykułu.',
  'Delete Security Group': 'Usuń Grupę Zabezpieczeń',
  'Are you sure you want to delete this security group?': 'Czy na pewno chcesz usunąć tę grupę zabezpieczeń?',
  'Group Name': 'Nazwa Grupy',
  'Group Description': 'Opis Grupy',
  'Security Group has been submitted successfully': 'Grupa Zabezpieczeń została pomyślnie zgłoszona',
  'Edit {{name}} Group': 'Edytuj Grupę {{name}}',
  'Add {{name}} Group': 'Dodaj Grupę {{name}}',
  'Assign Users': 'Przypisz Użytkowników',
  'Bin Information': 'Informacje o Pojemniku',
  'Multiple Product Bin': 'Pojemnik Mieszany',
  'ESL Tag': 'Etykieta ESL',
  'Location Name': 'Nazwa Lokalizacji',
  'Y position': 'Pozycja Y',
  'X position': 'Pozycja X',
  'Delete {{name}}': 'Usuń {{name}}',
  'Are you sure you want to delete this {{name}}?': 'Czy na pewno chcesz usunąć to {{name}}?',
  'Edit {{name}}': 'Edytuj {{name}}',
  'Add {{name}}': 'Dodaj {{name}}',
  'Search Production': 'Szukaj Produkcji',
  'No result': 'Brak wyników',
  'Add bin to the map': 'Dodaj pojemnik do mapy',
  'Add bins to the map': 'Dodaj pojemniki do mapy',
  'Successfully': 'Pomyślnie',
  'The changes you have made, are not saved.': 'Dokonane zmiany nie zostały zapisane.',
  'Do you wish to exit without saving ?': 'Czy chcesz wyjść bez zapisywania?',
  'No': 'Nie',
  'Yes': 'Tak',
  'No shelf map found!': 'Nie znaleziono mapy półek!',
  'The changes you have made, are not saved. Do you wish to exit without saving ?': 'Dokonane zmiany nie zostały zapisane. Czy chcesz wyjść bez zapisywania?',
  'Date Put': 'Data Zatowarowania',
  'Serial Numbers': 'Numery Seryjne',
  'Serial': 'Seryjny',
  'Are you sure you want to delete this serial number?': 'Czy na pewno chcesz usunąć ten numer seryjny?',
  'Delete serial number': 'Usuń numer seryjny',
  'Add serial number': 'Dodaj numer seryjny',
  'There is no enough space to add this bin': 'Nie ma wystarczającej ilości miejsca, aby dodać ten pojemnik',
  'There is no enough space to add this bin at selected position': 'Nie ma wystarczająco miejsca, aby dodać ten pojemnik w wybranym miejscu',
  'Do you want to clean map?': 'Czy chcesz wyczyścić mapę?',
  'This box can not be deleted.': 'Ten pojemnik nie może zostać usunięty.',
  'Assign Article': 'Przypisz Artykuł',
  'Delete Selected Box': 'Usuń Wybrany Pojemnik',
  'Clear Map': 'Wyczyść Mapę',
  'Zoom Out': 'Pomniejsz',
  'Zoom In': 'Powiększ',
  'Zoom': 'Powiększenie',
  'Delete selected': 'Usuń wybrane',
  'Exit fullscreen': 'Zamknij pełny ekran',
  'Fullscreen': 'Pełny ekran',
  'Successfully added': 'Pomyślnie dodano',
  'Must be a number': 'Musi być liczbą',
  'Edit shelf map': 'Edytuj mapę półek',
  'Add new shelf map': 'Dodaj nową mapę półek',
  'Map name': 'Nazwa mapy',
  'Map description': 'Opis mapy',
  'Left Gap': 'Lewa przerwa',
  'Right Gap': 'Prawa przerwa',
  'Top Gap': 'Górna przerwa',
  'Front Gap': 'Przednia przerwa',
  'Rear Gap': 'Tylna przerwa',
  'Divider Gap': 'Przerwa dzieląca',
  'Shelf Number': 'Numer Półki',
  'Shelf Name': 'Nazwa Półki',
  'Shelf Description': 'Opis Półki',
  'Shelf has been submitted successfully': 'Półka została pomyślnie dodana',
  'Edit {{name}} Shelf': 'Edytuj Półkę {{name}}',
  'Add {{name}} Shelf': 'Dodaj Półkę {{name}}',
  'Assign Shelf': 'Przypisz Półkę',
  'Assign Shelf to the map': 'Przypisz Półkę do mapy',
  'Saving...': 'Zapisywanie...',
  'Saving': 'Zapisywanie',
  'Are you sure you want to delete this shelf map? All record related to this shelf map will be deleted as well. This action cannot be undone.': 'Czy na pewno chcesz usunąć tę mapę półek? Wszystkie powiązane z nią dane zostaną również usunięte. Tej czynności nie można cofnąć.',
  'Delete shelf map': 'Usuń mapę półek',
  'Created By': 'Utworzony przez',
  'Add map': 'Dodaj mapę',
  'Templates': 'Szablony',
  'Smart Tag': 'Inteligentna Etykieta',
  'Template': 'Szablon',
  'Edit Smart Tag': 'Edytuj Inteligentną Etykietę',
  'Edit Template': 'Edytuj Szablon',
  'Add Smart Tag': 'Dodaj Inteligentną Etykietę',
  'Add Template': 'Dodaj Szablon',
  'Create New Smart Tag': 'Utwórz nową inteligentną etykietę',
  'Mac Address': 'Adres MAC',
  'IP Address': 'Adres IP',
  'Tag successfully added': 'Etykieta pomyślnie dodana',
  'Template Code': 'Kod Szablonu',
  'No user found!': 'Nie znaleziono użytkownika!',
  'Invalid email': 'Nieprawidłowy e-mail',
  'User successfully updated': 'Użytkownik pomyślnie zaktualizowany',
  'User has not updated': 'Nie zaktualizowano użytkownika',
  'Basic info, like your name and address that will displayed in public': 'Podstawowe informacje, takie jak imię i adres, które będą publicznie wyświetlane',
  'General': 'Ogólne',
  'User Name': 'Nazwa Użytkownika',
  'Updating...': 'Aktualizacja...',
  'RFID/Smart card code': 'Kod karty RFID/Smart',
  'User successfully created': 'Użytkownik pomyślnie utworzony',
  'User has not created': 'Nie utworzono użytkownika',
  'User successfully deleted': 'Użytkownik pomyślnie usunięty',
  'User has not deleted': 'Nie usunięto użytkownika',
  'User successfully enabled': 'Użytkownik pomyślnie włączony',
  'User has not enabled': 'Nie włączono użytkownika',
  'User successfully disabled': 'Użytkownik pomyślnie wyłączony',
  'User has not disabled': 'Nie wyłączono użytkownika',
  'Password Required': 'Wymagane Hasło',
  'Enter your new password': 'Wprowadź swoje nowe hasło',
  'Only Letters & Numbers Allowed': 'Dozwolone tylko Litery i Cyfry',
  'Password not match': 'Hasła nie są zgodne',
  'Enter your current & new password to reset your password': 'Wprowadź swoje aktualne i nowe hasło, aby zresetować hasło',
  'Current Password': 'Aktualne Hasło',
  'New Password': 'Nowe Hasło',
  'Password has not updated': 'Hasło nie zostało zaktualizowane',
  'Account': 'Konto',
  'UserName': 'Nazwa Użytkownika',
  'Successfuly Deleted': 'Pomyślnie Usunięto',
  'Product successfuly deleted': 'Produkt pomyślnie usunięty',
  'Add UOM': 'Dodaj JM',
  'Edit UOM': 'Edytuj JM',
  'Create New UOM': 'Utwórz Nową JM',
  'Are you sure you want to delete this UOM? All record related to this UOM will be deleted as well. This action cannot be undone.': 'Czy na pewno chcesz usunąć tę JM? Wszystkie dane z nią związane również zostaną usunięte. Tej czynności nie można cofnąć.',
  'Delete UOM': 'Usuń JM',
  'UOM successfully deleted': 'JM pomyślnie usunięta',
  'UOM has not deleted': 'JM nie została usunięta',
  'UOM successfully added': 'JM pomyślnie dodana',
  'Do you want to delete "{{zone}}"?': 'Czy chcesz usunąć "{{zone}}"?',
  'Do you want to delete "{{warehouse}}"?': 'Czy chcesz usunąć "{{warehouse}}"?',
  'Warehouse & Zones': 'Magazyn i Strefy',
  'Warehouse successfully updated': 'Magazyn pomyślnie zaktualizowany',
  'Zone successfully updated': 'Strefa pomyślnie zaktualizowana',
  'Zone successfully added': 'Strefa pomyślnie dodana',
  'Edit Warehouse': 'Edytuj Magazyn',
  'Edit Zone': 'Edytuj Strefę',
  'Create New Warehouse': 'Utwórz Nowy Magazyn',
  'Create New Zone': 'Utwórz Nową Strefę',
  'Zone successfully deleted': 'Strefa pomyślnie usunięta',
  'Warehouse successfully deleted': 'Magazyn pomyślnie usunięty',
  'Warehouse has not deleted': 'Magazyn nie został usunięty',
  'Zone has not deleted': 'Strefa nie została usunięta',

  'Add to Next Batch': 'Dodaj do Następnego Zestawu',
  'Add Article': 'Dodaj Artykuł',
  'Fixed Location': 'Stała Lokalizacja',
  'Total Quantity': 'Całkowita Ilość',
  'S-C': 'Półka-Przegroda',
  'Blocked': 'Zablokowany',
  'PTL RACK NAME': 'Nazwa regału PTL',
  'Bin Types': 'Typy Pojemników',
  // update 15/4/2026
  'Short': 'Brakujące',
  'Assigned to': 'Przypisano do',
  'Unassigned': 'Nieprzypisane',
  'By': 'Przez',
  'History': 'Historia',
  'Failed to update priority': 'Nie udało się zaktualizować priorytetu',
  'Error': 'Błąd',
  'Change State': 'Zmień Status',
  'Warehouse is required': 'Magazyn jest wymagany',
  'Zone is required': 'Strefa jest wymagana',
  'Print job sheet ...': 'Drukowanie arkusza zadań ...',
  'Print Job Sheet': 'Drukuj Arkusz Zadań',
  'Print MatchUp Sheet': 'Drukuj Arkusz MatchUp',
  'Run Batch': 'Uruchom Partię',
  'Close': 'Zamknij',
  'Run': 'Uruchom',
  'Batch run successfully': 'Partia uruchomiona pomyślnie',
  'Unable to communicate with PTL Controller : Batch run cannot be started': 'Nie można skomunikować się z kontrolerem PTL: Partia nie może zostać uruchomiona',
  'Paused': 'Wstrzymano',
  'Running': 'Uruchomiony',
  'The selected orders must have the same customer or shipping address.': 'Wybrane zamówienia muszą mieć tego samego klienta lub adres wysyłki.',
  'Job': 'Zadanie',
  'at': 'o',

  'Create Report': 'Utwórz Raport',
  'Report Section': 'Sekcja Raportu',
  'Select category': 'Wybierz kategorię',
  'Report title': 'Tytuł raportu',
  'Report description': 'Opis raportu',
  'Report file': 'Plik raportu',
  'File name': 'Nazwa pliku',
  'Report section is required': 'Sekcja raportu jest wymagana',
  'Report file is required': 'Plik raportu jest wymagany',
  'Add report': 'Dodaj raport',
  'Report': 'Raport',
  'Select a report': 'Wybierz raport',

  'Pivot Grid': 'Tabela Przestawna',
  'Stock on hand': 'Zapas na stanie',
  'Loading...': 'Ładowanie...',
  'Select a category': 'Wybierz kategorię',
  'Select an item': 'Wybierz element',
  'Region': 'Region',
  'City': 'Miasto',
  'Select': 'Wybierz',

  'Email Required': 'E-mail jest wymagany',
  'User Name Required': 'Nazwa użytkownika jest wymagana',
  'Phone number is not valid': 'Numer telefonu jest nieprawidłowy',
  'Personal Info': 'Informacje osobiste',
  'Social': 'Media społecznościowe',
  'Facebook link': 'Link do Facebooka',
  'Twitter link': 'Link do Twittera',
  'Pinterest link': 'Link do Pinteresta',
  'LinkedIn link': 'Link do LinkedIn',
  'URL': 'URL',
  'Phone Number': 'Numer telefonu',
  'Bags': 'Torby',
  'Cloths': 'Ubrania',
  'Shoes': 'Buty',
  'Watches': 'Zegarki',
  'In Stock': 'Na stanie',
  'Limited': 'Ograniczone',
  'Out Of Stock': 'Brak na stanie',
  'Delivery Reference': 'Numer dostawy',
  'Containers': 'Kontenery',
  'Reference': 'Referencja',
  'Line': 'Linia',
  'Edit Shelf': 'Edytuj Półkę',
  'Add Shelf': 'Dodaj Półkę',
  'Add Compartment': 'Dodaj komorę',
  'Edit Compartment': 'Edytuj komorę',
  'Assigning a new shelf map will delete all existing location data and create a new empty shelf.': 'Przypisanie nowej mapy półek spowoduje usunięcie wszystkich istniejących danych lokalizacji i utworzenie nowej pustej półki.',

  'Shipping': 'Wysyłka',
  'Dispatched': 'Wysłane',
  'Integration Fired': 'Integracja uruchomiona',
  'Pack & Dispatch': 'Pakowanie i wysyłka',
  'Tracking': 'Śledzenie',
  'Sort Bench': 'Stanowisko sortowania',
  'To Do': 'Do zrobienia',
  'Master List': 'Lista główna',
  'Remaining Items': 'Pozostałe pozycje',
  'Aurora AI': 'Aurora AI',
  'Forecasts': 'Prognozy',
  'No/Slow Moving': 'Bez/wolno rotujące',
  'Location Dashboard': 'Panel lokalizacji',
  'User Dashboard': 'Panel użytkownika',
  'ASRS': 'ASRS',
  'PTL Gateways & Devices': 'PTL Bramy i urządzenia',
  'Apply': 'Zastosuj',

  'Add User': 'Dodaj użytkownika',
  'Add Group': 'Dodaj grupę',
  'Add Bin': 'Dodaj regał',
  'In Transit': 'W tranzycie',
  'Delivered': 'Dostarczono',
  'Export file name': 'Nazwa pliku eksportu',
  'Tracking Number': 'Numer śledzenia',
  'Address': 'Adres',
  'Last Updated': 'Ostatnia aktualizacja',
  'Success': 'Sukces',
  'IP Port': 'Port IP',
  'DPI': 'DPI',
  'Printers': 'Drukarki',
  'Add Printer': 'Dodaj Drukarkę',
  'Printer Name': 'Nazwa Drukarki',
  'ZPL Printer': 'Drukarka ZPL',
  'Edit Printer': 'Edytuj Drukarkę',
  'Create New Printer': 'Utwórz Nową Drukarkę',
  'Delete Printer': 'Usuń Drukarkę',
  'Printer saved successfully': 'Drukarka została pomyślnie zapisana',
  'Printer deleted successfully': 'Drukarka została pomyślnie usunięta',
  'Are you sure you want to delete this printer? This action cannot be undone.': 'Czy na pewno chcesz usunąć tę drukarkę? Tej czynności nie można cofnąć.',
  'Jobs in Progress': 'Zadania w Toku',
  'Print Job Sheets': 'Drukuj Arkusze Zadań',
  'Print Rack Pick Sheets': 'Drukuj Arkusze Pobrań z Regału',
  'Print Automation Pick Sheets': 'Drukuj Arkusze Pobrań Automatycznych',
  'Search by article': 'Szukaj po artykule',
  'No results found': 'Nie znaleziono wyników',
  'Batch Run': 'Uruchomienie Partii',
  'Batch Size': 'Rozmiar Partii',
  'Pending Picks': 'Oczekujące Pobrania',
  'Article To Sort': 'Artykuły do Sortowania',
  'Sorted': 'Posortowane',
  'More': 'Więcej',
  'mins': 'min',
  'nav.apps.resources.printers': 'Drukarki',
  'nav.apps.shipping': 'Wysyłka',
  'nav.apps.shipping.dispatched': 'Wysłane',
  'nav.apps.shipping.packDispatch': 'Pakowanie i wysyłka',
  'nav.apps.shipping.tracking': 'Śledzenie',
  'nav.apps.sortBench': 'Stanowisko sortowania',
  'nav.apps.sortBench.dashboard': 'Panel',
  'nav.apps.sortBench.jobsInProgress': 'Zadania w Toku',
  'nav.apps.sortBench.todo': 'Do zrobienia',
  'nav.apps.sortBench.masterList': 'Lista główna',
  'nav.apps.sortBench.remainingItems': 'Pozostałe pozycje',
  'WorkLoad per Lift': 'Obciążenie na windę',
  'No data available': 'Brak dostępnych danych',
  'Puts': 'Zatowarowania',
  'Automation': 'Automatyzacja',
  'Unknown Lift': 'Nieznana winda',
  'Print Location Labels': 'Drukuj etykiety lokalizacji',
  'Sorter': 'Sortujący',
  'items': 'pozycje',
  'Complete Job': 'Zakończ zadanie',
  'All items are picked. Do you want to set this job status to Completed?': 'Wszystkie pozycje zostały skompletowane. Czy chcesz ustawić status zadania na „Zakończone”?',
}
